<div class="form-header-wrapper form-group">
    <div class="form-header" ngModelGroup="{{ formField.id }}">
        <div class="text-break w-100">
            <h1 class="form-header-title text-center" [ngClass]="{ 'mw-100': isImageHidden }">
                {{ formField.placeholder }}
            </h1>
            @if (!isImageHidden) {
                <img alt="" class="form-header-image" src="sb-tools/theme/images/form-hand.svg" />
            }
        </div>
    </div>
</div>
